module.exports = __webpack_public_path__ + "static/globus-1fd460bb10dabd827f80e0153dd1ccb2.svg";